export default function PlatformOverview() {
  return (<>
      <section className="section-space" id="platform">
        <div className="container">
          <div className="section-heading centered reveal">
            <div className="eyebrow">{"ONE PLATFORM"}</div>
            <h2>{"Start with what your business needs."}</h2>
            <p>{"Choose one capability today. Add more when you are ready. Everything is designed to work together."}</p>
          </div>

          <div className="suite-grid">
            <article className="suite-card reveal" data-suite="build">
              <div className="suite-icon">{"01"}</div>
              <h3>{"Build"}</h3>
              <p>{"Software, APIs, integrations and modernization."}</p>
              <div className="suite-details">
                <span>{"Multi-stack engineering"}</span>
                <span>{"Web & mobile development"}</span>
                <span>{"API development"}</span>
                <span>{"Existing code enhancement"}</span>
              </div>
              <a href="#technology">{"Explore Build "}<span>{"→"}</span></a>
            </article>

            <article className="suite-card reveal delay-1" data-suite="operate">
              <div className="suite-icon">{"02"}</div>
              <h3>{"Operate"}</h3>
              <p>{"DevOps, infrastructure and continuous operations."}</p>
              <div className="suite-details">
                <span>{"Managed DevOps"}</span>
                <span>{"Cloud infrastructure"}</span>
                <span>{"CI/CD & deployments"}</span>
                <span>{"Monitoring & recovery"}</span>
              </div>
              <a href="#technology">{"Explore Operate "}<span>{"→"}</span></a>
            </article>

            <article className="suite-card reveal delay-2" data-suite="secure">
              <div className="suite-icon">{"03"}</div>
              <h3>{"Test & Secure"}</h3>
              <p>{"QA, performance and security built into delivery."}</p>
              <div className="suite-details">
                <span>{"Manual & automated QA"}</span>
                <span>{"API & performance testing"}</span>
                <span>{"Security assessments"}</span>
                <span>{"Vulnerability management"}</span>
              </div>
              <a href="#technology">{"Explore Security "}<span>{"→"}</span></a>
            </article>

            <article className="suite-card reveal" data-suite="payments">
              <div className="suite-icon">{"04"}</div>
              <h3>{"Accept & Reconcile"}</h3>
              <p>{"Payments, QR, checkout, collections and reconciliation."}</p>
              <div className="suite-details">
                <span>{"Payment integration"}</span>
                <span>{"P2M QR"}</span>
                <span>{"Hosted checkout"}</span>
                <span>{"Reconciliation"}</span>
              </div>
              <a href="#payments">{"Explore Payments "}<span>{"→"}</span></a>
            </article>

            <article className="suite-card reveal delay-1" data-suite="engage">
              <div className="suite-icon">{"05"}</div>
              <h3>{"Engage"}</h3>
              <p>{"Customer support, CRM and WhatsApp AI."}</p>
              <div className="suite-details">
                <span>{"Managed customer support"}</span>
                <span>{"CRM"}</span>
                <span>{"WhatsApp AI agent"}</span>
                <span>{"Human escalation"}</span>
              </div>
              <a href="#experience">{"Explore Engage "}<span>{"→"}</span></a>
            </article>

            <article className="suite-card reveal delay-2" data-suite="run">
              <div className="suite-icon">{"06"}</div>
              <h3>{"Run"}</h3>
              <p>{"Business apps for bookings, orders and operations."}</p>
              <div className="suite-details">
                <span>{"Booking management"}</span>
                <span>{"Order management"}</span>
                <span>{"Builder management"}</span>
                <span>{"Reports & notifications"}</span>
              </div>
              <a href="#apps">{"Explore Apps "}<span>{"→"}</span></a>
            </article>
          </div>
        </div>
      </section>

      <section className="split-section section-space dark-section" id="technology">
        <div className="container">
          <div className="section-heading reveal">
            <div className="eyebrow light">{"SOFTWARE + MANAGED SERVICES"}</div>
            <h2>{"Software when you want control."}<br />{"Experts when you need help."}</h2>
            <p>{"Use the platform yourself, let our specialists operate it for you, or combine both."}</p>
          </div>

          <div className="two-mode-grid">
            <article className="mode-card reveal">
              <div className="mode-label">{"SOFTWARE"}</div>
              <h3>{"Move fast with self-service tools."}</h3>
              <ul>
                <li>{"Activate products instantly"}</li>
                <li>{"Self-service dashboard"}</li>
                <li>{"APIs and integrations"}</li>
                <li>{"Real-time reporting"}</li>
                <li>{"Flexible subscriptions"}</li>
                <li>{"Scale usage anytime"}</li>
              </ul>
              <a href="#pricing" className="btn btn-light">{"Explore Software"}</a>
            </article>

            <article className="mode-card accent reveal delay-1">
              <div className="mode-label">{"MANAGED"}</div>
              <h3>{"Let specialists handle the operational load."}</h3>
              <ul>
                <li>{"Dedicated specialists"}</li>
                <li>{"Setup & implementation"}</li>
                <li>{"Ongoing operations"}</li>
                <li>{"Monitoring & optimization"}</li>
                <li>{"SLA-based support"}</li>
                <li>{"Human escalation"}</li>
              </ul>
              <a href="#managed" className="btn btn-primary">{"Explore Managed Services"}</a>
            </article>
          </div>

          <div className="big-statement reveal">{"Use it yourself. Let us manage it. Or combine both."}</div>
        </div>
      </section>

  </>);
}
